import { Flashcard, FlashcardSet } from "@knowt/syncing/graphql/schema";
import { useFlashcardSet } from "@knowt/syncing/hooks/flashcards/useFlashcards";
import { Dispatch, RefObject, SetStateAction } from "react";
import { VirtuosoHandle } from "react-virtuoso";

export type SetEditingContextValue = {
    /** Source of truth `flashcardSet` on flashcards edit page */
    flashcardSet: FlashcardSet | null | undefined;
    /** Source of truth for updating `flashcardSet.flashcards` on flashcards edit page */
    updateFlashcards: ReturnType<typeof useFlashcardSet>["updateFlashcards"];
    /** Source of truth of buffer/pending on flashcards edit page */
    pendingUpdates: RefObject<{
        metadata: Partial<Omit<FlashcardSet, "flashcards">>;
        flashcards: { [flashcardId: string]: Partial<Flashcard> };
    }>;
    /** Source of truth for adding a new flashcard on flashcards edit page */
    addFlashcard: ReturnType<typeof useFlashcardSet>["addFlashcard"];
    /** Source of truth for adding multiple new flashcard on flashcards edit page */
    addFlashcards: ReturnType<typeof useFlashcardSet>["addFlashcards"];
    /** Source of truth for deleting flashcard on flashcards edit page */
    deleteFlashcard: ReturnType<typeof useFlashcardSet>["deleteFlashcard"];
    /** Source of truth for deleting multiple flashcard on flashcards edit page */
    deleteFlashcards: ReturnType<typeof useFlashcardSet>["deleteFlashcards"];
    /** Source of truth for updating flashcard set metadata on flashcards edit page */
    updateFlashcardSetMetaData: ReturnType<typeof useFlashcardSet>["updateFlashcardSetMetaData"];
    /** Source of truth to swap all terms-become-definitions on flashcards edit page */
    handleSwapTermsDefinitions: () => Promise<void>;
    putPendingUpdatesInSWRCache: () => Promise<void>;
    flashcardsHandlesMap: Map<string, FlashcardForceUpdateContentCb>;
    handleSave: (skipCreation?: boolean) => Promise<boolean | undefined>;
    isSaving: boolean;
    lastSaved: number;
    virtuosoRef: RefObject<VirtuosoHandle | null> | null;
    isChatSplitSectionOpen: boolean;
    setIsChatSplitSectionOpen: Dispatch<SetStateAction<boolean>>;
    readOnly: boolean;
};

export type FlashcardForceUpdateContentCb = { forceUpdateContent: (flashcard: Flashcard) => void | null };

export enum SavingMessage {
    SUCCESS = "Flashcards Saved!",
    FAILURE = "Could not Save Flashcards",
}

export type FlashcardSortable = Flashcard & {
    // `dnd-kit` Sortable only support name id with key `id`
    id: string;
    index: number;
};
